const languageInfo = [
  { code: 'br', originalName: 'Brezhoneg', englishName: 'Breton' },
  { code: 'ca', originalName: 'Català', englishName: 'Catalan' },
  { code: 'cn', originalName: '简体中文', englishName: 'Simplified Chinese' },
  { code: 'de', originalName: 'Deutsch', englishName: 'German' },
  { code: 'els', originalName: 'Elsässich', englishName: 'Alsatian' },
  { code: 'en', originalName: 'English', englishName: 'English' },
  { code: 'es', originalName: 'Español', englishName: 'Spanish' },
  { code: 'eo', originalName: 'Esperanto', englishName: 'Esperanto' },
  { code: 'eu', originalName: 'Euskara', englishName: 'Basque' },
  { code: 'fr', originalName: 'Français', englishName: 'French' },
  {
    code: 'frp',
    originalName: 'Arpetan',
    englishName: 'Arpitan / Francoprovençal',
  },
  { code: 'fur', originalName: 'Furlan', englishName: 'Friulian' },
  { code: 'galo', originalName: 'Galo', englishName: 'Gallo' },
  { code: 'it', originalName: 'Italiano', englishName: 'Italian' },
  { code: 'oc', originalName: 'Occitan', englishName: 'Occitan' },
  { code: 'pcd', originalName: 'Picard', englishName: 'Picard' },
  { code: 'pl', originalName: 'Polski', englishName: 'Polish' },
  {
    code: 'pt-br',
    originalName: 'Português (Brasil)',
    englishName: 'Portuguese (Brazil)',
  },
  { code: 'tnt', originalName: 'Trentin', englishName: 'Trentin' },
].sort((a, b) => a.originalName.localeCompare(b.originalName));

const texts = {
  en: {
    id: 'ID',
    eventLabel: 'Event',
    round: 'Round',
    group: 'Group',
    station: 'Station',
    name: 'Name',
    newCompetitor: 'New competitor',
    newCompetitor_short: 'New',
    scr: 'Scr',
    check: 'Check',
    result: 'Result',
    judge: 'Judge',
    comp: 'Comp',
    extra: 'Extra attempt',
    extra_short: 'Extra',
    delegateInitials: 'Delegate initials',
    delegateInitials_short: 'Delegate',
    cutoff: 'Cutoff',
    timeLimit: 'Time limit',
    total: 'total',
    eventName: {
      '333': '3x3x3 Cube',
      '222': '2x2x2 Cube',
      '444': '4x4x4 Cube',
      '555': '5x5x5 Cube',
      '666': '6x6x6 Cube',
      '777': '7x7x7 Cube',
      '333bf': '3x3x3 Blindfolded',
      '333fm': '3x3x3 Fewest Moves',
      '333oh': '3x3x3 One-Handed',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 Blindfolded',
      '555bf': '5x5x5 Blindfolded',
      '333mbf': '3x3x3 Multi-Blind',
    },
  },
  br: {
    eventLabel: 'Amprouenn',
    round: 'Tro',
    group: 'Stroll',
    station: "Lec'h",
    name: 'Anv',
    newCompetitor: 'Kenstrivadeg kentañ',
    newCompetitor_short: 'Nevez',
    scr: 'Mesk',
    check: 'Gwir',
    result: "Disoc'h",
    judge: 'Barn',
    comp: 'Kens',
    extra: 'Adtaol-esae',
    extra_short: 'Adtaol',
    delegateInitials: 'Dileuriad',
    delegateInitials_short: 'Dileuriad',
    cutoff: 'Amzer termen',
    timeLimit: 'Harz-amzer',
    total: 'hollad',
    eventName: {
      '333': 'Diñs 3x3x3',
      '222': 'Diñs 2x2x2',
      '444': 'Diñs 4x4x4',
      '555': 'Diñs 5x5x5',
      '666': 'Diñs 6x6x6',
      '777': 'Diñs 7x7x7',
      '333bf': '3x3 daoul. mouchet',
      '333fm': '3x3x3 diluziadur gwellekaet',
      '333oh': '3x3x3 gant un dorn',
      minx: 'Megaminks',
      pyram: 'Piraminks',
      clock: 'Klok',
      skewb: 'Skyoub',
      sq1: 'Skouer-Ouann',
      '444bf': '4x4 daoul. mouchet',
      '555bf': '5x5 daoul. mouchet',
      '333mbf': 'Meur a 3x3 daoul. m.',
    },
  },
  ca: {
    eventLabel: 'Categoria',
    round: 'Ronda',
    group: 'Grup',
    station: 'Estació',
    name: 'Nom',
    newCompetitor: 'Nou competidor',
    newCompetitor_short: 'Nou',
    scr: 'Bar',
    result: 'Resultat',
    judge: 'Jutge',
    comp: 'Comp',
    extra: 'Intent extra',
    extra_short: 'Extra',
    delegateInitials: 'Inicials del delegat',
    delegateInitials_short: 'Delegat',
    cutoff: 'Tall',
    timeLimit: 'Temps límit',
    total: 'acumulatiu',
    eventName: {
      '333': 'Cub 3x3x3',
      '222': 'Cub 2x2x2',
      '444': 'Cub 4x4x4',
      '555': 'Cub 5x5x5',
      '666': 'Cub 6x6x6',
      '777': 'Cub 7x7x7',
      '333bf': '3x3x3 Cega',
      '333fm': '3x3x3 Menys Moviments',
      '333oh': '3x3x3 Una mà',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 Cega',
      '555bf': '5x5x5 Cega',
      '333mbf': 'Múltiples 3x3x3 a Cegues',
    },
  },
  cn: {
    eventLabel: '项目',
    round: '轮次',
    group: '组别',
    station: '赛台',
    id: '编号',
    name: '姓名',
    newCompetitor: '新人选手',
    scr: '打乱',
    check: '核对',
    result: '成绩',
    judge: '裁判',
    comp: '选手',
    extra: '额外尝试（备用打乱）',
    delegateInitials: '代表签名',
    cutoff: '及格线',
    timeLimit: '还原时限',
    total: '累计',
    eventName: {
      '333': '三阶',
      '222': '二阶',
      '444': '四阶',
      '555': '五阶',
      '666': '六阶',
      '777': '七阶',
      '333bf': '三盲',
      '333fm': '最少步',
      '333oh': '单手',
      minx: '五魔方',
      pyram: '金字塔',
      clock: '魔表',
      skewb: '斜转',
      sq1: 'SQ1',
      '444bf': '四盲',
      '555bf': '五盲',
      '333mbf': '多盲',
    },
  },
  els: {
    eventLabel: 'd’Leischtùng',
    round: 'Kehr',
    group: 'Grùpp',
    station: 'Schtàz.',
    name: 'd’r Nàmme',
    newCompetitor: 'Näileng',
    newCompetitor_short: 'Näileng',
    scr: 'Misch',
    check: 'Nooh',
    result: 's’Resultatt',
    judge: 'Richt',
    comp: 'Wett',
    extra: 'Extra',
    extra_short: 'Extra',
    delegateInitials: 'Delegue',
    delegateInitials_short: 'Delegue',
    cutoff: 'Cutoff',
    timeLimit: 'd’Zittgranza',
    total: 'gsàmt',
    eventName: {
      '333': '3x3x3 Wìrfel',
      '222': '2x2x2 Wìrfel',
      '444': '4x4x4 Wìrfel',
      '555': '5x5x5 Wìrfel',
      '666': '6x6x6 Wìrfel',
      '777': '7x7x7 Wìrfel',
      '333bf': '3x3x3 blind',
      '333fm': '3x3x3 weniger Bewejùnge',
      '333oh': '3x3x3 aihandig',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 blind',
      '555bf': '5x5x5 blind',
      '333mbf': '3x3x3 mehrfàch blind',
    },
  },
  es: {
    eventLabel: 'Categoría',
    round: 'Ronda',
    group: 'Grupo',
    station: 'Est',
    name: 'Nombre',
    newCompetitor: 'Nuevo competidor',
    newCompetitor_short: 'Nuevo',
    scr: 'Mez',
    result: 'Resultado',
    judge: 'Juez',
    comp: 'Comp',
    extra: 'Intento extra',
    extra_short: 'Extra',
    delegateInitials: 'Iniciales del delegado',
    delegateInitials_short: 'Delegado',
    cutoff: 'Corte',
    timeLimit: 'Tiempo límite',
    total: 'acumulativo',
    eventName: {
      '333': 'Cubo 3x3x3',
      '222': 'Cubo 2x2x2',
      '444': 'Cubo 4x4x4',
      '555': 'Cubo 5x5x5',
      '666': 'Cubo 6x6x6',
      '777': 'Cubo 7x7x7',
      '333bf': '3x3x3 Ciega',
      '333fm': '3x3x3 Menos Movimientos',
      '333oh': '3x3x3 Una Mano',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 Ciega',
      '555bf': '5x5x5 Ciega',
      '333mbf': '3x3x3 Multi Ciega',
    },
  },

  eo: {
    eventLabel: 'Konkursero',
    round: "Raŭnd'",
    group: 'Grupo',
    station: 'Stacio',
    name: 'Nomo',
    newCompetitor: 'Nova konkursanto',
    newCompetitor_short: 'Novulo',
    scr: 'Miks',
    check: 'Kontr',
    result: 'Rezulto',
    judge: 'Juĝ',
    comp: 'Part',
    extra: 'Ekstra solvo',
    extra_short: 'Ekstra',
    delegateInitials: 'Inicialoj de la Delegito',
    delegateInitials_short: 'Delegito',
    cutoff: 'Ĉestempo',
    timeLimit: 'Tempolimo',
    total: 'entute',
    eventName: {
      '333': 'Kubo 3x3x3',
      '222': 'Kubo 2x2x2',
      '444': 'Kubo 4x4x4',
      '555': 'Kubo 5x5x5',
      '666': 'Kubo 6x6x6',
      '777': 'Kubo 7x7x7',
      '333bf': '3x3x3 Blinde',
      '333fm': '3x3x3 Optimigita Solvo',
      '333oh': '3x3x3 Unumane',
      minx: 'Megaminkso',
      pyram: 'Piraminkso',
      clock: 'Kloko',
      skewb: 'Skjubo',
      sq1: 'Skŭaro-1',
      '444bf': '4x4x4 Blinde',
      '555bf': '5x5x5 Blinde',
      '333mbf': '3x3x3 Pluraj kuboj blinde',
    },
  },
  eu: {
    eventLabel: 'Proba',
    round: 'Txanda',
    group: 'Taldea',
    station: 'Post',
    name: 'Izena',
    newCompetitor: 'Lehiakide berria',
    newCompetitor_short: 'Berria',
    scr: 'Nah',
    result: 'Emaitza',
    judge: 'Epai',
    comp: 'Lehi',
    extra: 'Saiakera extra',
    extra_short: 'Extra',
    delegateInitials: 'Ordezkariaren inizialak',
    delegateInitials_short: 'Ordezkari',
    cutoff: 'Ebaki-denbora',
    timeLimit: 'Denbora-muga',
    total: 'osotara',
    eventName: {
      '333': '3x3x3 Kuboa',
      '222': '2x2x2 Kuboa',
      '444': '4x4x4 Kuboa',
      '555': '5x5x5 Kuboa',
      '666': '6x6x6 Kuboa',
      '777': '7x7x7 Kuboa',
      '333bf': '3x3x3 Itsututa',
      '333fm': '3x3x3 Mugimendu gutxien',
      '333oh': '3x3x3 Esku batekin',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 Itsututa',
      '555bf': '5x5x5 Itsututa',
      '333mbf': '3x3x3 Multi-Itsututa',
    },
  },
  fr: {
    eventLabel: 'Épreuve',
    round: 'Tour',
    group: 'Groupe',
    station: 'Station',
    name: 'Nom',
    newCompetitor: 'Première compétition',
    newCompetitor_short: 'Nouveau·elle',
    scr: 'Mél',
    check: 'Vérif',
    result: 'Résultat',
    judge: 'Juge',
    comp: 'Comp',
    extra: 'Extra',
    extra_short: 'Extra',
    delegateInitials: 'Initiales Délégué·e',
    delegateInitials_short: 'Délégué·e',
    cutoff: 'Cutoff',
    timeLimit: 'Limite de temps',
    total: 'au total',
    eventName: {
      '333': 'Cube 3x3x3',
      '222': 'Cube 2x2x2',
      '444': 'Cube 4x4x4',
      '555': 'Cube 5x5x5',
      '666': 'Cube 6x6x6',
      '777': 'Cube 7x7x7',
      '333bf': "3x3x3 à l'aveugle",
      '333fm': '3x3x3 résolution optimisée',
      '333oh': '3x3x3 à une main',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': "4x4x4 à l'aveugle",
      '555bf': "5x5x5 à l'aveugle",
      '333mbf': "3x3x3 multiples à l'aveugle",
    },
  },
  frp: {
    eventLabel: 'Èprôva',
    round: 'Tôrn',
    group: 'Groupo',
    station: 'Staci.',
    name: 'Nom',
    newCompetitor: 'Premiére compèticion',
    scr: 'Mècl',
    check: 'Vèrif',
    result: 'Rèsultat',
    judge: 'Jujo',
    comp: 'Comp',
    extra: 'Extra',
    delegateInitials: 'Dèlègâ',
    cutoff: 'Cutoff',
    timeLimit: 'Limita de temps',
    total: 'totâl',
    eventName: {
      '333': 'Cubo 3x3x3',
      '222': 'Cubo 2x2x2',
      '444': 'Cubo 4x4x4',
      '555': 'Cubo 5x5x5',
      '666': 'Cubo 6x6x6',
      '777': 'Cubo 7x7x7',
      '333bf': "3x3x3 a l'avogllo",
      '333fm': '3x3x3 rèsolucion optimisâye',
      '333oh': '3x3x3 a yona man',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': "4x4x4 a l'avogllo",
      '555bf': "5x5x5 a l'avogllo",
      '333mbf': "Plus. 3x3 a l'avogllo",
    },
  },
  fur: {
    eventLabel: 'Event',
    round: 'Turno',
    group: 'Grup',
    station: 'Stazion',
    name: 'Nomp',
    newCompetitor: 'Nouf partecipant',
    scr: 'Masc',
    result: 'Risultât',
    judge: 'Giud',
    comp: 'Part',
    extra: 'Tentatîf extra',
    delegateInitials: 'Iniziâls dal delegât',
    cutoff: 'Tai',
    timeLimit: 'Timp masimp',
    total: 'totâl',
    eventName: {
      '333': 'Cubo 3x3x3',
      '222': 'Cubo 2x2x2',
      '444': 'Cubo 4x4x4',
      '555': 'Cubo 5x5x5',
      '666': 'Cubo 6x6x6',
      '777': 'Cubo 7x7x7',
      '333bf': '3x3x3 da bendât',
      '333fm': '3x3x3 cun mancul rotazions',
      '333oh': "3x3x3 cunt'una man",
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Orloi',
      skewb: 'Skewb',
      sq1: 'Quadrât-1',
      '444bf': '4x4x4 da bendât',
      '555bf': '5x5x5 da bendât',
      '333mbf': '3x3x3 Plui cubos da bendât',
    },
  },
  galo: {
    eventLabel: 'Assaot',
    round: 'Tour',
    group: 'Groupe',
    station: 'Station',
    name: 'Nom',
    newCompetitor: 'Permiere course',
    newCompetitor_short: 'Nouviao',
    scr: 'Mél',
    check: 'Contr',
    result: 'Fezûre',
    judge: 'Juje',
    comp: 'Cours',
    extra: 'Ajis',
    extra_short: 'Ajis',
    delegateInitials: 'Déléguë·ée',
    delegateInitials_short: 'Déléguë·ée',
    cutoff: 'Temp de pâssaje',
    timeLimit: 'Temp limite',
    total: 'en tout',
    eventName: {
      '333': 'Qhube 3x3x3',
      '222': 'Qhube 2x2x2',
      '444': 'Qhube 4x4x4',
      '555': 'Qhube 5x5x5',
      '666': 'Qhube 6x6x6',
      '777': 'Qhube 7x7x7',
      '333bf': '3x3x3 bôgné',
      '333fm': '3x3x3 chieu le pus court',
      '333oh': '3x3x3 o ene main',
      minx: 'Megaminx',
      pyram: 'Piraminx',
      clock: 'Cloc',
      skewb: 'Skyoub',
      sq1: 'Sqouère-Ouane',
      '444bf': '4x4x4 bôgné',
      '555bf': '5x5x5 bôgné',
      '333mbf': 'Puzieurs 3x3x3 bôgné',
    },
  },
  pl: {
    eventLabel: 'Konkurencja',
    round: 'Runda',
    group: 'Grupa',
    station: 'Stan',
    name: 'Imię i nazwisko',
    newCompetitor: 'Nowicjusz',
    newCompetitor_short: 'Nowicjusz',
    scr: 'Miesz',
    check: 'Spr',
    result: 'Wynik',
    judge: 'Sędz',
    comp: 'Zaw',
    extra: 'Dodatkowe ułożenie',
    // TODO check with Polish speakers
    extra_short: 'Extra',
    delegateInitials: 'Inicjały delegata',
    delegateInitials_short: 'Delegata',
    cutoff: 'Cutoff',
    timeLimit: 'Limit czasowy',
    total: 'łącznie',
    eventName: {
      '333': 'Kostka 3x3x3',
      '222': 'Kostka 2x2x2',
      '444': 'Kostka 4x4x4',
      '555': 'Kostka 5x5x5',
      '666': 'Kostka 6x6x6',
      '777': 'Kostka 7x7x7',
      '333bf': '3x3x3 Bez patrzenia',
      '333fm': '3x3x3 Najmniejsza liczba ruchów',
      '333oh': '3x3x3 Jedną ręką',
      '444bf': '4x4x4 Bez patrzenia',
      '555bf': '5x5x5 Bez patrzenia',
      '333mbf': '3x3x3 Multi-Blind',
    },
  },
  'pt-br': {
    eventLabel: 'Categoria',
    round: 'Round',
    group: 'Grupo',
    station: 'Est',
    name: 'Nome',
    newCompetitor: 'Novo competidor',
    scr: 'Emb',
    check: 'Conf',
    result: 'Resultado',
    judge: 'Juiz',
    comp: 'Comp',
    extra: 'Tentativa extra',
    delegateInitials: 'Iniciais do delegado',
    delegateInitials_short: 'Delegado',
    cutoff: 'Tempo de corte',
    timeLimit: 'Tempo limite',
    total: 'cumulativo',
    eventName: {
      '333': 'Cubo 3x3x3',
      '222': 'Cubo 2x2x2',
      '444': 'Cubo 4x4x4',
      '555': 'Cubo 5x5x5',
      '666': 'Cubo 6x6x6',
      '777': 'Cubo 7x7x7',
      '333bf': '3x3x3 Vendado',
      '333fm': '3x3x3 em Menos Movimentos',
      '333oh': '3x3x3 com Uma Mão',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 Vendado',
      '555bf': '5x5x5 Vendado',
      '333mbf': '3x3x3 Múltiplos Cubos Vendado',
    },
  },
  it: {
    eventLabel: 'Evento',
    round: 'Turno',
    group: 'Gruppo',
    station: 'Stazione',
    name: 'Nome',
    newCompetitor: 'Nuovo partecipante',
    newCompetitor_short: 'Nuovo',
    scr: 'Scr',
    result: 'Risultato',
    judge: 'Giud',
    comp: 'Part',
    extra: 'Tentativo extra',
    extra_short: 'Extra',
    delegateInitials: 'Iniziali del delegato',
    delegateInitials_short: 'Delegato',
    cutoff: 'Taglio',
    timeLimit: 'Tempo limite',
    total: 'totale',
    eventName: {
      '333': 'Cubo 3x3x3',
      '222': 'Cubo 2x2x2',
      '444': 'Cubo 4x4x4',
      '555': 'Cubo 5x5x5',
      '666': 'Cubo 6x6x6',
      '777': 'Cubo 7x7x7',
      '333bf': '3x3x3 da Bendato',
      '333fm': '3x3x3 Fewest Moves',
      '333oh': '3x3x3 con una Mano',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 da Bendato',
      '555bf': '5x5x5 da Bendato',
      '333mbf': '3x3x3 Multiplo da Bendato',
    },
  },
  de: {
    eventLabel: 'Disziplin',
    round: 'Runde',
    group: 'Gruppe',
    station: 'Station',
    name: 'Name',
    newCompetitor: 'Neuer Teilnehmer',
    newCompetitor_short: 'Neu',
    scr: 'Scr',
    result: 'Ergebnis',
    judge: 'Judge',
    comp: 'Teil',
    extra: 'extra Versuch',
    extra_short: 'Extra',
    delegateInitials: 'Delegates Initialen',
    delegateInitials_short: 'Delegate',
    cutoff: 'cutoff',
    timeLimit: 'Zeitlimit',
    total: 'gesamt',
    eventName: {
      '333': '3x3x3 Würfel',
      '222': '2x2x2 Würfel',
      '444': '4x4x4 Würfel',
      '555': '5x5x5 Würfel',
      '666': '6x6x6 Würfel',
      '777': '7x7x7 Würfel',
      '333bf': '3x3x3 Blind',
      '333fm': '3x3x3 Fewest Moves',
      '333oh': '3x3x3 Einhändig',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 Blind',
      '555bf': '5x5x5 Blind',
      '333mbf': '3x3x3 Mehrfach Blind',
    },
  },
  tnt: {
    eventLabel: 'Evènto',
    round: 'Turno',
    group: 'Grup',
    station: 'Pòst',
    name: 'Nòm',
    newCompetitor: 'Nof partecipante',
    newCompetitor_short: 'Nof',
    scr: 'Mis',
    result: 'Tèmp',
    judge: 'Giùd',
    comp: 'Part',
    extra: 'Tentatif èxtra',
    extra_short: 'Èxtra',
    delegateInitials: 'Iniziai del delegà',
    delegateInitials_short: 'Delegà',
    cutoff: 'Tai',
    timeLimit: 'Tèmp lìmite',
    total: 'total',
    eventName: {
      '333': 'Cubo 3x3x3',
      '222': 'Cubo 2x2x2',
      '444': 'Cubo 4x4x4',
      '555': 'Cubo 5x5x5',
      '666': 'Cubo 6x6x6',
      '777': 'Cubo 7x7x7',
      '333bf': '3x3x3 sènza vardar',
      '333fm': '3x3x3 Fewest Moves',
      '333oh': '3x3x3 con na man',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 sènza vardar',
      '555bf': '5x5x5 sènza vardar',
      '333mbf': 'tanti 3x3x3 sènza vardar',
    },
  },
  pcd: {
    eventLabel: "Épreuf'",
    round: "Ch'tour",
    group: "Ch'gro.",
    station: 'Estati.',
    name: 'Nom',
    newCompetitor: "Nouvieu ch'compétiteur",
    scr: 'Mél.',
    check: 'Révis.',
    result: "R'zultat",
    judge: 'Juche',
    comp: "Ch'co.",
    extra: 'Extro',
    delegateInitials: 'Délédjé',
    cutoff: 'Cutoff',
    timeLimit: 'Timp limite',
    total: 'total',
    eventName: {
      '333': 'Tchube 3x3x3',
      '222': 'Tchube 2x2x2',
      '444': 'Tchube 4x4x4',
      '555': 'Tchube 5x5x5',
      '666': 'Tchube 6x6x6',
      '777': 'Tchube 7x7x7',
      '333bf': '3x3x3 chés zius bindés',
      '333fm': "3x3x3 résoulution l'pu courte",
      '333oh': '3x3x3 à éne main',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 chés zius bindés',
      '555bf': '5x5x5 chés zius bindés',
      '333mbf': 'Pusieurs 3x3x3 chés zius bindés',
    },
  },
  oc: {
    eventLabel: 'Espròva',
    round: 'Torn',
    group: 'Grop',
    station: 'Estaci.',
    name: 'Nom',
    newCompetitor: 'Primièra competicion',
    scr: 'Mesc',
    check: 'Verif',
    result: 'Resultat',
    judge: 'Jutge',
    comp: 'Comp',
    extra: 'Extrà',
    delegateInitials: 'Delegat·da',
    cutoff: 'Talh',
    timeLimit: 'Temps limit',
    total: 'au totau',
    eventName: {
      '333': 'Cube 3x3x3',
      '222': 'Cube 2x2x2',
      '444': 'Cube 4x4x4',
      '555': 'Cube 5x5x5',
      '666': 'Cube 6x6x6',
      '777': 'Cube 7x7x7',
      '333bf': '3x3x3 òrb',
      '333fm': '3x3x3 mens de movements',
      '333oh': '3x3x3 a una man',
      minx: 'Megaminx',
      pyram: 'Pyraminx',
      clock: 'Clock',
      skewb: 'Skewb',
      sq1: 'Square-1',
      '444bf': '4x4x4 òrb',
      '555bf': '5x5x5 òrb',
      '333mbf': "Mai d'un 3x3x3 òrbs",
    },
  },
};

export const translation = language => texts[language];
export default languageInfo;
